<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel && (DataType==11)"
        :title="$t('edit')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'1000px','max-height':'800px'}">
        
        <Form ref="formDynamic" :model="formDynamic" :rules="ruleCustom" :label-width="80" >
        
             <div v-for="(item, index) in formDynamic.items" :key="index">

                 <!-- Bitvalue:{key1:'Name-CN', key7:"Name-EN",key2:'Offset',key3:'Len',key4:'Multiple',key5:'Negative',key6:'LanguageKey',key8:'wordId',key9:'pageId_wordId'} -->

                <div style="display:flex;justify-content:flex-start;flex-wrap:wrap"  v-show="item.status">

                    <FormItem    :label="$t('BasicProduct.funcBox.titleName.LanguageKey') + item.index"  :prop="'items.' + index + '.'+languageKey.key6"  style="width:470px"
                         :rules="{required: item.status===1?true:false, message: languageKey.key6 + item.index +' can not be empty', trigger: 'change'}">
        
                         
                         <div v-if="isGener && !item.hasWord" class="ivu-input">{{ item.LanguageKey }} {{ local=='zh-CN'?item['Name-CN']:item['Name-EN'] }}</div>
                         
                         <template v-else>
                            <SearchSelectPage  :refName="'select'+index" listName="dealersList"  :showPage="true" :ref="'select'+index" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,item.index)"></SearchSelectPage>
                        </template>


                    </FormItem>



                    <FormItem    :label="$t('BasicProduct.funcBox.titleName.Offset') + item.index"  :prop="'items.' + index + '.'+languageKey.key2"  style="width:470px"
                         :rules="{required: item.status===1?true:false, message: languageKey.key2 + item.index +' can not be empty', trigger: 'blur'}">
                        <Input type="number" v-model="item[languageKey.key2]" :placeholder="$t('inputPlaceholder')"></Input>
                          
                    </FormItem>
                      <FormItem    :label="$t('BasicProduct.funcBox.titleName.Len') + item.index"  :prop="'items.' + index + '.'+languageKey.key3"  style="width:470px"
                         :rules="{required: item.status===1?true:false, message: languageKey.key3 + item.index +' can not be empty', trigger: 'blur'}">
                         <Input type="number" v-model="item[languageKey.key3]" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>

                    <FormItem    :label="$t('BasicProduct.funcBox.titleName.Multiple') + item.index"  :prop="'items.' + index + '.'+languageKey.key4"  style="width:470px"
                         :rules="{required: item.status===1?true:false, message: languageKey.key4 + item.index +' can not be empty', trigger: 'blur'}">
                        <Input type="number" v-model="item[languageKey.key4]" :placeholder="$t('inputPlaceholder')"></Input>
                          
                    </FormItem>
                    
                    <FormItem  :label="$t('BasicProduct.funcBox.titleName.Negative')+ item.index" :prop="'items.' + index + '.'+languageKey.key5" style="width: 470px"
                    :rules="{required: item.status===1?true:false, message: languageKey.key4 + item.index +' can not be empty', trigger: 'change'}">
                        <RadioGroup v-model="item[languageKey.key5]">
                             <Radio label="Y">
                                 <span>Y</span>
                             </Radio>
                             <Radio label="N">
                                 <span>N</span>
                             </Radio>
                         </RadioGroup>
                    </FormItem>

                 
                    
                    <FormItem  v-if="!isGener "   style="width:100px" class="delButton">
                       <Button type="error" :disabled="enumDelDisabled" @click="handleRemove(index)">{{$t("delete")}}</Button>
                    </FormItem>
                </div>
                 
             </div>
             <FormItem  v-if="!isGener ">
                <Row>
                    <Col span="12">
                        <Button type="dashed" long @click="handleAdd" icon="md-add">{{$t("add")}}</Button>
                    </Col>
                </Row>
            </FormItem>
           
            <FormItem v-if="isGener ">
                <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
            </FormItem>

             <FormItem v-else >
                <Button type="primary" @click="handleSubmit('formDynamic')">{{$t("save")}}</Button>
                <!-- <Button @click="handleReset('formDynamic')" style="margin-left: 8px">{{$t("reset")}}</Button> -->
                <Button @click="cancel" style="margin-left: 8px">{{$t("cancel")}}</Button>
            </FormItem>

        </Form>

    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'
// import SearchSelectPage from '@/views/common/selectListPage.vue';  //20220415
import SearchSelectPage from '@/views/common/selectListRecycle.vue';  //20220415

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            pageId:[Number, String],
            editFormData:Object,
            DataType:String,
            keyType:{
                type:[Number, String],
                default:1
            },
            // languageKey:Object,
            // initdata:Object,

            isGener:{
                type:Boolean,
                default:false
            },
            readOnly:{
                type:Boolean,
                default:false
            }
        },
        components:{
            SearchSelectPage
        },
        name: "Model6",
        data() {
            return {   
                pagesIdListUrl: this.config.urlArray.pagesLangDictionaryList,//对应pageId的词条列表

                disabled: false,//禁用确定按钮
                title: '设置',//弹框标题
                formData: {//表单数据
                   
                }, 
                index: 1,
                formDynamic: {
                    items: [
                       {'Name-CN':'',"Name-EN":"",Offset:'',Len:'',Multiple:'',Negative:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}
                    ],
                },
                descText:'',
                enumDelDisabled:true,
                wordList:[],
                wordListLoading:false,
                pageID:'',
                languageKey:{key1:'Name-CN', key7:"Name-EN",key2:'Offset',key3:'Len',key4:'Multiple',key5:'Negative',key6:'LanguageKey',key8:'wordId',key9:'pageId_wordCode'},
                initdata:{'Name-CN':'',"Name-EN":"",Offset:'',Len:'',Multiple:'',Negative:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}
               
            }
        },
        computed:{
            ...mapState(['local','selectId','wordListAll','wordListByPageId','pageIdStore']),
             ruleCustom(){
                 return {//验证
                    orderId: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    
                    qty: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                }
             } 

        },
        created(){
            this.pageID = this.pageId || this.pageIdStore || ''
        },
        methods: {
            setSelectValPage(selItem,index){
                if(selItem){
                   (this.formDynamic.items[index-1])[this.languageKey.key8] = selItem.id+'';
                   (this.formDynamic.items[index-1])[this.languageKey.key6] = selItem.wordCode+'' || '';
                   (this.formDynamic.items[index-1])[this.languageKey.key9] = this.pageID+'_'+selItem.wordCode+''||'';
                   (this.formDynamic.items[index-1])[this.languageKey.key1] = selItem.simpleChinese+''|| '';
                   (this.formDynamic.items[index-1])[this.languageKey.key7] = selItem.englishText+''||''
                }else{
                    this.clearSelectVal(index)
                }
            },
            clearSelectVal(index){
                (this.formDynamic.items[index-1])[this.languageKey.key8] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key6] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key9] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key1] = '';
                (this.formDynamic.items[index-1])[this.languageKey.key7] = ''
            },

            setDefaultSelectPage(){
                for(let i=0;i<this.formDynamic.items.length;i++){
                    let param = {
                        id:this.formDynamic.items[i].wordId,
                        wordCode:this.formDynamic.items[i].LanguageKey
                    }
                    this.$nextTick(()=>{
                        if(this.$refs['select'+i] && this.$refs['select'+i][0]){

                            this.$refs['select'+i][0].setDefVal(param) 
                        }
                    })
                }
            },
          
           
            handleSubmit (name) {
                if(this.isGener){
                    return
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        
                        const arr1 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1.LanguageKey)
                        const arr2 = new Set(arr1)


                        // const arr3 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1[this.languageKey.key6])
                        // const arr4 = new Set(arr3)
                        
                        // console.log('arr1',arr1)
                        
                        if(arr1.length<1){
                            this.$Message.error('提交内容为空');
                            return
                        }else if(arr2.size!=arr1.length){
                            this.$Message.error(this.$t('BasicProduct.funcBox.titleName.LanguageKey')+'重复');
                            return
                        }
                        // else if(arr3.length > arr4.size){
                        //     this.$Message.error(this.$t('BasicProduct.funcBox.titleName.Name')+'重复');
                        //     return
                        // }
                        // console.log('arr1',arr1)


                        let emitArr = this.formDynamic.items.filter((item)=>{
                           return  item.status==1
                        }).map(item=>{
                            delete item.status
                            delete item.index
                            delete item.hasWord
                            // console.log('item[this.languageKey.key9]',item[this.languageKey.key9])
                            if(!item[this.languageKey.key9]){
                                item[this.languageKey.key9] = this.pageID+'_'+item[this.languageKey.key6]+''
                            }

                            return item
                        })
                        
                        // console.log('emitArr',emitArr)
                        this.fn(emitArr,this.descText)
               
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
            handleAdd () {
                this.index++;
                let obj = {...this.initdata,index: this.index}
                this.formDynamic.items.push(obj)

                let arr = this.formDynamic.items.filter(item=>item.status)
                if(arr.length>1) this.enumDelDisabled = false

                let len = this.formDynamic.items.length-1

                this.$nextTick(()=>{
                    this.$refs['select'+len][0].getData()
                })

            },
            handleRemove (index) {
                this.formDynamic.items[index].status = 0;
                this.$nextTick(()=>{
                    this.$refs['select'+index][0].clearVal()
                })
                let arr = this.formDynamic.items.filter(item=>item.status)
                if(arr.length<2) this.enumDelDisabled = true
                this.$forceUpdate()
            },
            async openOrClose(value) {
                if(value === true) {
                    // console.log('this.editFormData',this.editFormData)

 
                    if(this.type==1){
                        this.index = 1
                        this.formDynamic.items = [common.deepClone(this.initdata)]
                        // this.formDynamic.items = common.deepClone( [{...this.initdata}])
                        this.enumDelDisabled = true

                        this.$refs['select0'][0].getData()


                    }else{

                        if(Object.keys(this.editFormData).length>0){
                            // this.formDynamic.items = [...this.editFormData.IndentyName]
                            this.formDynamic.items = common.deepClone([...this.editFormData.IndentyName])

                            let flag = 1
                            this.formDynamic.items.map((item)=>{
                                if(!item.LanguageKey){
                                    flag=0
                                }
                            })
                            if(flag==0){
                                for(let i=0;i<this.editFormData.IndentyName.length;i++){
                                    for(let j=0;j<this.formDynamic.items.length;j++){
                                        if(this.editFormData.IndentyName[i].pageId_wordCode==this.formDynamic.items[j].pageId_wordCode && !this.formDynamic.items[j].LanguageKey){
                                            this.formDynamic.items[j].LanguageKey = this.editFormData.IndentyName[i].LanguageKey
                                            this.formDynamic.items[j].Multiple = this.editFormData.IndentyName[i].Multiple
                                            this.formDynamic.items[j].Len = this.editFormData.IndentyName[i].Len
                                            this.formDynamic.items[j].Offset = this.editFormData.IndentyName[i].Offset
                                            this.formDynamic.items[j].Negative = this.editFormData.IndentyName[i].Negative
                                        }
                                    }
                                }
                            }

                            this.setDefaultSelectPage()

                              console.log('this.formDynamic.items',this.formDynamic.items)
                                // console.log('this.editFormData.IndentyName',this.editFormData.IndentyName)
                            this.index = this.editFormData.IndentyName.length
                            if(this.formDynamic.items.length>1) this.enumDelDisabled = false
                        }
                    }
                }else{
                    for(let i=0;i<this.formDynamic.items.length;i++){
                        if(this.$refs['select'+i]){

                            this.$refs['select'+i][0].clearVal()
                        }
                    }
                }
            },
            cancel() {//对话框关闭
                this.resetForm();//重置表单
                
                this.$emit('update:showSetModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formDynamic.resetFields();//重置表单
                for(let i=0;i<this.formDynamic.items.length;i++){
                    if(this.$refs['select'+i]){
                        this.$refs['select'+i][0].clearVal()
                    }
                }
                this.formDynamic.items = common.deepClone( [{...this.initdata}])
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
     .ivu-modal-body {
        max-height: 800px;
        // overflow-y: scroll;
        overflow: auto;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}

/deep/ .ivu-input[disabled]{
    background-color: #ffffff;
    color: #515a6e;
}

.delButton {
    /deep/ .ivu-form-item-content {
    margin-left: 20px !important;
 }
}
</style>

